import { Button, Card, Icon } from "antd";
import { CardProps } from "antd/lib/card";
import * as React from "react";
import { Link } from "react-router-dom";
import "./PbrCard.scss";

interface IPbrCardProps {
  showLinkButton?: boolean
  linkButtonUrl?: string
  linkButtonIcon?: string
  linkButtonTitle?: string
}

export function PbrCard(props: CardProps & IPbrCardProps) {
  return (
    <Card {...props} className={`pbr-card ${props.className ? props.className : ""}`}>
      {props.showLinkButton &&
        <Link to={props.linkButtonUrl}>
          <Button className="btn button-back-page"><Icon style={{ fontSize: "15px", color: "#3d81ff" }} type={props.linkButtonIcon} />{props.linkButtonTitle}</Button>
        </Link>
      }
      {props.children}
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/PbrCard/PbrCard.tsx